export const userProfileConfig = {
  store: {
    key: 'users',
  },
  routes: {
    resetPassword: 'reset-password',
  },
};
